<div class="w-100 mt-0 px-0 d-flex flex-column justify-content-center align-items-center maintenance-bg mt-0">
  <div class="m-auto d-flex justify-content-center flex-column flex-lg-row maintenance align-items-center">
    <img class="logo mb-lg-5 mb-4" src="assets/images/Logos/RedbullsMemberPlusWhite.svg" />
    <div class="content-container text-center">
      <div class="text-primary icon material-icons">engineering</div>
      <h5 class="text-primary my-1 text-uppercase" [innerHTML]="'maintenance.page.title' | translate | markdownTranslate"></h5>
      <div class="font-size-14" [innerHTML]="'maintenance.page.details' | translate | markdownTranslate"></div>
    </div>
  </div>
</div>
<div class="pb-5 pt-2">
  <fgbcl-preview />
</div>
